export const defaultSampleAccountData = {
    email: 'john.doe@test-juvare.com',
    firstName: 'John',
    lastName: 'Doe',
    consent: false,
    orgRole: {},
    orgStatus: {},
    systemRole: '',
    systemStatus: 'active',
};
